"use client";

import { Fragment } from "react";
import SiteHeader from "~/app/(site)/components/SiteNavbar";

import { COMMON_LOCALES } from "~/core/constants/locales/common";
import Heading from "~/core/ui/Heading";

import OutlinedButton from "~/components/Buttons/OutlinedButton";

const ErrorPage = () => {
  return (
    <Fragment>
      <SiteHeader />

      <div
        className={
          "m-auto flex min-h-[50vh] w-full items-center justify-center"
        }
      >
        <div className={"flex flex-col space-y-8"}>
          <div
            className={"flex space-x-8 divide-x divide-border-core-silver-3"}
          >
            <div>
              <Heading type={1}>
                <span className={"text-darker"}>500</span>
              </Heading>
            </div>

            <div className={"flex flex-col space-y-4 pl-8"}>
              <div className={"flex flex-col space-y-2"}>
                <div>
                  <Heading type={1}>{COMMON_LOCALES.genericError}</Heading>
                </div>

                <p className="text-light">
                  {COMMON_LOCALES.genericErrorSubHeading}
                </p>
              </div>

              <div className={"flex space-x-4"}>
                <OutlinedButton
                  size="large"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  Back to previous page
                </OutlinedButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ErrorPage;
